import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import { DashboardButton } from './DashboardButton';

export const DashboardButtonPopup = observer(({ item, onClick, testId }) => {
  return (
    <Popup
      content={item?.helpText}
      data-testid={`${testId}-${item.text}-popup`}
      header={item?.aliasText}
      key={`popup-${item.text}`}
      position={item?.popupPosition}
      size="tiny"
      trigger={
        <div>
          <DashboardButton
            item={item}
            testId={testId}
            onClick={() => onClick(item)}
          />
        </div>
      }
    />
  );
});

export default DashboardButtonPopup;
